import React from "react";
import { Form, FormikProvider, useFormik } from "formik";

import { CustomButton, CustomDialog, FeaturedIcon } from "../../../components";

import css from "./modals.module.css";
import { useMutation } from "../../../hooks/use-mutation";
import RebatesClient from "../../../RebatesClient";

const ModalUserRemove = ({
  open,
  onClose,
  onDeleteComplete,
  activeUser,
  account
}) => {
  const { mutateAsync: submitRequest, isLoading, } = useMutation({
    mutationKey: "deleteUser",
    networkMode: "always",
    mutationFn: async () =>  await RebatesClient.deleteUser(activeUser?.id, account?.id, activeUser?.user_role),
    onError: (err)=> {console.log(err)},
    onSuccess: (resp) => {
      if(resp.response.status == 200){
        onDeleteComplete()
      }
      else {
        alert(`${resp.body.status}`)
      }

    }
  });

  console.log(activeUser?.id, account?.id, activeUser?.user_role)

  const formik = useFormik({
    initialValues:{user_id: activeUser?.id},
    validationSchema:null,
    onSubmit: submitRequest
  });

  const title = (
    <div className={css.modalTitle}>
      <FeaturedIcon icon="Trash" />
      Remove User
    </div>
  );

  return (
      <CustomDialog open={open} onClose={onClose} width={440} title={title}>
        <FormikProvider value={formik}>
          <Form className={css.modalForm}>
            <div className={css.formContent}>
              <div className={css.formGroup}>
                <p>Are you sure you want to remove <strong>{activeUser?.first_name} {activeUser?.last_name}</strong>?</p>
              </div>
            </div>

            <div className={css.actions}>
              <CustomButton
                label="Remove"
                type="submit"
                color="danger"
                onSubmit={formik.handleSubmit}
              />
            </div>
          </Form>
        </FormikProvider>
      </CustomDialog>
  );
}

export default ModalUserRemove;
